import { Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, GridOptions } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import { PatientDataService } from '../../patient-data.service';
import { restoreGridOverlays, restoreRowSelection } from '../../../common/services/ag-grid-compat';

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
  selector: 'app-drg-selector',
  templateUrl: './drg-selector.component.html'
})
export class DrgSelectorComponent implements OnInit {
  @Input() hospitalId: string | number;
  @Input() hospitalTeamName: string;
  @Input() dischargeDate: string;
  @Input() careTypeId?: string | number;
  @Input() drgWithValue?: string;
  saveDisabled: boolean = true;
  gridOptions: GridOptions = {};
  private selectedRow: any;
  private gridApi: GridApi;
  private drgApiSubscription: Subscription;

  constructor(public activeModal: NgbActiveModal, private ptService: PatientDataService) {}

  ngOnInit(): void {
    this.gridOptions.columnDefs = [
      { field: 'msdrgCode', headerName: 'MS-DRG', width: 110, minWidth: 110,
        filter: 'agNumberColumnFilter', valueGetter: (params) => parseInt(params.data.msdrgCode) },
      { field: 'msdrgTitle', headerName: 'MS-DRG Title', cellClass: 'ag-grid-cell-wrap', minWidth: 640 }
    ];
    this.gridOptions.components = {};
    this.gridOptions.defaultColDef = { sortable: true, resizable: true, filter: "agTextColumnFilter" };
    this.gridOptions.defaultColDef.floatingFilter = true;
    this.gridOptions.pagination = true;
    this.gridOptions.paginationPageSize = 25;
    this.gridOptions.suppressCellFocus = true;
    this.gridOptions.singleClickEdit = false;
    this.gridOptions.getRowHeight = this.getRowHeight;
  }

  getRowHeight(params) {
    if( params.data && params.data.msdrgTitle && params.data.msdrgTitle.length > 88 ) {
      return 50;
    } else {
      return 25;
    }
  }

  onGridReady(params) {
    this.gridApi = params.api;
    restoreGridOverlays(this.gridApi);
    restoreRowSelection(this.gridApi, 'single');
    this.gridApi.showLoadingOverlay();
    this.gridApi.sizeColumnsToFit();
    this.drgApiSubscription = this.ptService.getMSDRGs(this.hospitalId.toString(), this.dischargeDate, this.hospitalTeamName, this.careTypeId)
      .subscribe(res => {
        this.gridOptions.rowData = res.data;
        this.gridApi.hideOverlay();
      },() => {
        this.gridApi.hideOverlay();
        this.gridOptions.rowData = [];
      });
  }

  rowSelected(row: any) {
    this.selectedRow = row.data;
    this.saveDisabled = false;
  }

  onFirstDataRendered() {
    if ( this.drgWithValue ){
      let obj = {
        "msdrgCode": {
          "filterType": "number",
          "operator": "AND",
          "condition1": {
            "filterType": "number",
            "type": "greaterThanOrEqual",
            "filter": parseInt(this.drgWithValue),
            "filterTo": null
          },
          "condition2": {
            "filterType": "number",
            "type": "lessThan",
            "filter": parseInt(this.drgWithValue) + 5,
            "filterTo": null
          }
        }
      }
      this.gridApi.setFilterModel(obj);
    }
  }

  saveData() {
    this.activeModal.close(this.selectedRow);
  }

}
